//left in for ajax / anything else that
//is using jquery
var $body = jQuery('.js-body');

//Global vars
const body = document.querySelector(".js-body"),
    homeScroll = document.querySelector(".js-header-home-scroll"),
    darkThemeScroll = document.querySelector(".js-dark-theme-scroll"),
    header = document.querySelector(".js-header"),
    headerHeight = header.offsetHeight,
    thisPage = body.dataset.page;
    //   site = body.dataset.site;

let width = window.innerWidth,
    height = window.innerHeight,
    scrollPos = 0,
    triggerPoint = 0;

    if (thisPage == 'page--home') { 
        triggerPoint = height + headerHeight;
    } else {
        triggerPoint = headerHeight;
    }